import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyParcel({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.9 145.5c-42.86 4.43-60.36 17.5-100.9 15.93-47.85-1.86-89.92-36.47-66.05-74.93C31.15 57.16 67 62.5 98 38s63.31-27.7 85.5-14c40 28 90.89 111.73-3.6 121.5z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.4 154.01c12.74-3.2 26.35-6.63 44.5-8.5 43.23-4.48 56.03-24.42 53.37-47.43-6.35-8.92-17.15-15.62-35.54-13.08-17.85 2.47-31.02 6.21-43.85 9.86C133.9 100.56 114.75 106 80 106c-32.55 0-53.97-11.06-66.37-20.57-.23.35-.46.7-.68 1.07-23.87 38.46 18.2 73.07 66.05 74.93 23.37.9 39.08-3.05 56.4-7.42z"
        fill="#8F9DD6"
      />
      <path d="M67 67h106v67H67V67z" fill="#FDB444" />
      <path d="M77 46h86l10 21H67l10-21z" fill="#FFC252" />
      <path d="M108 85.5V67h24.5v18.5l-13-5.5-11.5 5.5z" fill="#F9F6A3" fillOpacity={0.7} />
      <path d="M132.5 67H108l2.5-21H130l2.5 21z" fill="#FFFCB5" fillOpacity={0.8} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77 108.49l6.04-7.49 6.03 7.49H77zm8.2 0h-4.33v13.93h4.33v-13.93zm5.73 0l6.03-7.49 6.04 7.49H90.93zm3.7 0v13.93h4.34v-13.93h-4.33zm-16.7 15.42v3.7h24.14v-3.7H77.93z"
        fill="#DA9326"
      />
      <circle cx={173} cy={130} r={21.75} fill="#fff" stroke="#7E90DC" strokeWidth={4.5} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M171.63 126.86a3.43 3.43 0 104.55 4.43h11.4v-2.58h-11.4a3.44 3.44 0 00-1.98-1.92V115h-2.57v11.86z"
        fill="#56A"
      />
    </svg>
  );
}

SvgPicEmptyParcel.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyParcel.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicEmptyParcel svgRef={ref} {...props} />);
export default ForwardRef;
